//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* jshint jquery: true */
/* global angular: false */
import dropdownOptionTemplate from '@partials/dropdown-option.html';

(function() {
  angular.module('curalate')
        /*
         * dropdown-option is a sub-component of the 'dropdown' component and represents a single option in the dropdown.
         *
         * @attr name   The user-facing name of the option
         * @attr value  The value of the option that is sent in the callback function of the parent scope.
         * @attr icon   (Optional) One or more classes that represent an icon that should be displayed along with the 'name' field.
         */
        .directive('dropdownOption', () => ({
          restrict: 'E',
          replace: true,
          scope: {
            name: '@',
            value: '=',
            icon: '@',
          },
          require: '^dropdown',
          template: dropdownOptionTemplate,
          link(scope, element, attrs, dropdown) {
            scope.model = {
              isHighlighted: false,
              dynamicAttr: false,
            };

                    // If "dynamic" attribute is set, then the name (and value, icon) can change dynamically.
            if (attrs.$attr.dynamic) {
              scope.model.dynamicAttr = true;
              scope.$watch('name', (newValue, oldValue) => {
                if (oldValue && (newValue !== oldValue)) {
                  dropdown.checkSelectOptionNameChanged(newValue, oldValue);
                }
              });
            } else {
              scope.model.dynamicAttr = false;
            }

                    // Notify parent component that a new option has been added
            dropdown.registerOption({
              name: scope.name,
              value: scope.value,
              icon: scope.icon,
              highlight() {
                scope.$apply(() => {
                  scope.model.isHighlighted = true;
                });
              },
              unhighlight() {
                scope.$apply(() => {
                  scope.model.isHighlighted = false;
                });
              },
            });

            scope.update = function(name, value, icon) {
              dropdown.selectOption({
                name,
                value,
                icon,
              });
            };

            scope.highlight = function() {
              scope.isHighlighted = true;
            };
          },
        }));
})();
